import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FirstPage from "./FirstPage";
import SecondPage from "./SecondPage";
import ThirdPage from "./ThirdPage";
import FourthPage from "./FourthPage";
import FifthPage from "./FifthPage";
import "./index.css";
import { useListContext } from "../../../../contexts/listContext";
import { toPng } from "html-to-image";
import CombinedReportComponent from "./CombinedReportComponent";

const PDFDocument = () => {
  const contentRef = useRef();

  const userInfo = JSON.parse(localStorage.getItem("PAuser"));

  // const { list, checkedPlatforms, abuse_type, dateFilter, setDateFilter } = useListContext();

  const [topSuspectedBrands, setTopSuspectedBrands] = useState([]);
  const [topSuspectedSellers, setTopSuspectedSellers] = useState([]);
  const [topInfringingPlatforms, setTopInfringingPlatforms] = useState([]);
  const [brandWise, setBrandWise] = useState([]);
  const [platformWise, setPlatformWise] = useState([]);
  const [test, setTest] = useState([]);
  const [dateFilter, setDateFilter] = useState({});
  const [name, setName] = useState("");
  const [failureAlert, setFailureAlert] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const dateFilter = searchParams.get("dateFilter");
    const name = searchParams.get("brand");
    setName(name);
    setDateFilter(JSON.parse(dateFilter));
  }, [window.location]);

  const fetchTopSuspectedBrand = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(
        `${backendUrl}/api/report/topSuspectedBrands`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            durationType: dateFilter,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('TopSuspectedBrands fetched')
        setTopSuspectedBrands(json.data);
        //console.log("topSuspectedBrands", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in fetchProducts");
    }
  };

  const fetchTopSuspectedSellers = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(
        `${backendUrl}/api/report/topSuspectedSellers`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            durationType: dateFilter,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('TopSuspectedSellers fetched')
        setTopSuspectedSellers(json.data);
        //console.log("TopSuspectedSellers", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in setTopSuspectedSellers");
    }
  };

  // const handleSuccessAlert = async (alertMessage) => {
  //     setSuccessAlert(alertMessage);
  //     setTimeout(() => {
  //       setSuccessAlert('');
  //     }, 5000);
  //   }

  const handleFailureAlert = async (alertMessage) => {
    setFailureAlert(alertMessage);
    setTimeout(() => {
      setFailureAlert("");
    }, 5000);
  };

  const fetchTopInfringingPlatforms = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(
        `${backendUrl}/api/report/topInfringingPlatforms`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            durationType: dateFilter,
          }),
        }
      );
      const json = await response.json();
      if (response.ok) {
        //console.log('TopInfringingPlatforms fetched')
        setTopInfringingPlatforms(json.data);
        //console.log("TopInfringingPlatforms", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in TopInfringingPlatforms");
    }
  };

  const fetchBrandWise = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/report/brandWise`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          durationType: dateFilter,
        }),
      });
      const json = await response.json();
      if (response.ok) {
        //console.log('setBrandWise fetched')
        setBrandWise(json.data);
        //console.log("setBrandWise", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in setBrandWise");
    }
  };

  const fetchPlatformWise = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/report/platformWise`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          durationType: dateFilter,
        }),
      });
      const json = await response.json();
      if (response.ok) {
        //console.log('PlatformWise fetched')
        setPlatformWise(json.data);
        //console.log("PlatformWise", json.data);
      } else if (response.status !== 400) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in PlatformWise");
    }
  };

  const fetchTest = async () => {
    try {
      //console.log("param", userInfo?.message?.result.id);
      const response = await fetch(`${backendUrl}/api/report/testCount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          durationType: dateFilter,
        }),
      });
      const json = await response.json();
      if (response.ok) {
        //console.log('testCount fetched')
        setTest(json.data);
        //console.log("testCoutn", json.data);
      } else if (response.status !== 200) {
        //console.log(json);
        //console.log("Error Fetching Data");
        handleFailureAlert("Error fetching Data");
      }
    } catch (e) {
      //console.log("error in testCount", e);
    }
  };

  useEffect(() => {
    fetchTopSuspectedBrand();
    fetchTopSuspectedSellers();
    fetchTopInfringingPlatforms();
    fetchBrandWise();
    fetchPlatformWise();
    fetchTest();
  }, [userInfo?.message?.result.id, dateFilter]);

  const handleDownload = async () => {
    const node = contentRef.current;

    setIsDownloading(true);

    try {
      const dataUrl = await toPng(node, {
        cacheBust: true,
        pixelRatio: 2,
        backgroundColor: "#ffffff",
        style: {
          margin: "0",
          padding: "0",
        },
      });

      const img = new Image();
      img.src = dataUrl;

      img.onload = () => {
        const a4WidthPt = 595.28; // Standard A4 width
        const imgWidth = img.width;
        const imgHeight = img.height;
        const ratio = a4WidthPt / imgWidth;
        const scaledHeight = imgHeight * ratio;

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "pt",
          format: [a4WidthPt, scaledHeight], // Dynamic height
        });

        pdf.addImage(dataUrl, "PNG", 0, 0, a4WidthPt, scaledHeight);
        pdf.save("report.pdf");
        setIsDownloading(false);
      };

      img.onerror = () => {
        setIsDownloading(false);
        handleFailureAlert("Error generating PDF");
      };
    } catch (err) {
      console.error("Error generating PDF:", err);
      setIsDownloading(false);
      handleFailureAlert("Error generating PDF");
    }
  };

  // Loader Component
  const LoaderOverlay = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        flexDirection: "column",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "12px",
          textAlign: "center",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          maxWidth: "300px",
          width: "90%",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #007bff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }}
        ></div>
        <h3
          style={{
            margin: "0 0 10px",
            color: "#333",
            fontSize: "18px",
            fontWeight: "600",
          }}
        >
          Generating PDF...
        </h3>
        <p
          style={{
            margin: 0,
            color: "#666",
            fontSize: "14px",
          }}
        >
          Please wait while we prepare your report
        </p>
      </div>
    </div>
  );

  return (
    <div style={{ backgroundColor: "white", position: "relative" }}>
      {/* Add spinner keyframes to your CSS */}
      <style>
        {`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    
                    .download-button {
                        background-color: #007bff;
                        color: white;
                        border: none;
                        padding: 12px 24px;
                        border-radius: 6px;
                        cursor: pointer;
                        font-size: 16px;
                        font-weight: 500;
                        transition: all 0.3s ease;
                        margin: 20px;
                    }
                    
                    .download-button:hover:not(:disabled) {
                        background-color: #0056b3;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
                    }
                    
                    .download-button:disabled {
                        background-color: #6c757d;
                        cursor: not-allowed;
                        transform: none;
                        box-shadow: none;
                    }
                `}
      </style>

      {/* Loader Overlay */}
      {isDownloading && <LoaderOverlay />}

      <button
        onClick={handleDownload}
        className="download-button"
        disabled={isDownloading}
      >
        {isDownloading ? "Generating PDF..." : "Download PDF"}
      </button>

      <div
        ref={contentRef}
        className="pdf-container"
        style={{
          width: "100%",
          maxWidth: "800px",
          margin: "0 auto",
          padding: 0,
          background: "white",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <FirstPage brandName={name} />

        {/* <SecondPage topSuspectedBrands={topSuspectedBrands}
                    topSuspectedSellers={topSuspectedSellers}
                    topInfringingPlatforms={topInfringingPlatforms} />
                <ThirdPage brandWise={brandWise}
                    platformWise={platformWise} />
                <FourthPage test={test} /> */}
        <CombinedReportComponent
          brandName={name}
          topSuspectedBrands={topSuspectedBrands}
          topSuspectedSellers={topSuspectedSellers}
          topInfringingPlatforms={topInfringingPlatforms}
          brandWise={brandWise}
          platformWise={platformWise}
          test={test}
        />

        <FifthPage />
      </div>

      <button
        onClick={handleDownload}
        className="download-button"
        disabled={isDownloading}
      >
        {isDownloading ? "Generating PDF..." : "Download PDF"}
      </button>
    </div>
  );
};

export default PDFDocument;
